import { useMemo } from 'react';
import { Drawer } from '@cad-arc';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { SpecialAssignmentDrawerContent } from './special-assignment-drawer-content';

export const SpecialAssignmentDrawer = function SpecialAssignmentDrawer({
    unitId,
    statusId,
}: {
    unitId?: number;
    statusId?: number;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const closeDrawer = useMemo(
        () => () => {
            drawerControls.close();
        },
        [drawerControls]
    );

    return (
        <Drawer variant="overlay" isOpen={true} size="lg" onClose={closeDrawer}>
            <SpecialAssignmentDrawerContent
                unitId={unitId}
                statusId={statusId}
                closeDrawer={closeDrawer}
            />
        </Drawer>
    );
};

type SpecialAssignmentDrawerType = typeof SpecialAssignmentDrawer;
export type { SpecialAssignmentDrawerType };
